/**
 * Wave 10 zod-mandate — runtime schemas for `registerBackgroundSync`.
 *
 * @example
 * ```ts
 * import { RegisterBackgroundSyncSchema } from './ServiceWorker.schema'
 * RegisterBackgroundSyncSchema.parse({ serviceWorkerUrl: '/sw.js', tag: 'sync' })
 * ```
 */
import { z } from 'zod'

export const RegisterBackgroundSyncSchema = z
	.object({
		serviceWorkerUrl: z.string().min(1),
		tag: z.string().min(1),
	})
	.strict()

export type RegisterBackgroundSyncInput = z.infer<
	typeof RegisterBackgroundSyncSchema
>
